import type * as Types from '../../generated/graphql-types';

import { gql } from '@apollo/client';
import { PessoaBasicFieldsFragmentDoc } from '../pessoas/fragments.generated';
export type ResponsaveisOnAlunosFieldsFragment = { __typename: 'ResponsaveisOnAlunosType', alunoId: number, responsavelId: number, ativo: boolean, grauParentesco: string, responsavelFinanceiro: boolean, responsavelAcademico: boolean, autorizadoBuscar: boolean, contatoEmergencia: boolean, guardaCompartilhada: boolean, prioridadeContato: number, observacoes?: string | null, aluno: { __typename: 'AlunoType', id: number, matricula: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, dataNascimento?: any | null, fotoUrl?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, genero?: string | null } | null, matriculas: Array<{ __typename: 'MatriculaType', id: number, status: Types.StatusMatricula, dataMatricula: any, turma: { __typename: 'TurmaType', id: number, nome: string, anoLetivo?: { __typename: 'AnoLetivoType', id: number, ano: number, dataInicio: any, dataFim: any } | null, escola: { __typename: 'EscolaType', id: number, nomeFantasia: string, nomeOficial?: string | null } } }>, fichaMedica?: { __typename: 'FichaMedicaType', id: number, tipoSanguineo?: string | null, alergias?: string | null, condicoesMedicas?: string | null, medicamentosContinuos?: string | null, contatoEmergenciaNome?: string | null, contatoEmergenciaTelefone?: string | null, contatoEmergenciaParentesco?: string | null, laudosMedicos?: Array<string> | null, criadoEm?: any | null, atualizadoEm?: any | null } | null } };

export type ResponsavelCompletoFieldsFragment = { __typename: 'ResponsavelType', id: number, pessoaId: number, pessoa: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, telefoneFixo?: string | null, profissao?: string | null, escolaridade?: string | null, localTrabalho?: string | null, fotoUrl?: string | null, status: Types.StatusPessoa }, filhos: Array<{ __typename: 'ResponsaveisOnAlunosType', alunoId: number, responsavelId: number, ativo: boolean, grauParentesco: string, responsavelFinanceiro: boolean, responsavelAcademico: boolean, autorizadoBuscar: boolean, contatoEmergencia: boolean, guardaCompartilhada: boolean, prioridadeContato: number, observacoes?: string | null, aluno: { __typename: 'AlunoType', id: number, matricula: string, pessoa?: { __typename: 'PessoaType', id: number, nome: string, nomeSocial?: string | null, dataNascimento?: any | null, fotoUrl?: string | null, cpf?: string | null, email?: string | null, telefoneCelular?: string | null, genero?: string | null } | null, matriculas: Array<{ __typename: 'MatriculaType', id: number, status: Types.StatusMatricula, dataMatricula: any, turma: { __typename: 'TurmaType', id: number, nome: string, anoLetivo?: { __typename: 'AnoLetivoType', id: number, ano: number, dataInicio: any, dataFim: any } | null, escola: { __typename: 'EscolaType', id: number, nomeFantasia: string, nomeOficial?: string | null } } }>, fichaMedica?: { __typename: 'FichaMedicaType', id: number, tipoSanguineo?: string | null, alergias?: string | null, condicoesMedicas?: string | null, medicamentosContinuos?: string | null, contatoEmergenciaNome?: string | null, contatoEmergenciaTelefone?: string | null, contatoEmergenciaParentesco?: string | null, laudosMedicos?: Array<string> | null, criadoEm?: any | null, atualizadoEm?: any | null } | null } }> };


export const ResponsaveisOnAlunosFieldsFragmentDoc = gql`
    fragment ResponsaveisOnAlunosFields on ResponsaveisOnAlunosType {
    alunoId
    responsavelId
    ativo
    grauParentesco
    responsavelFinanceiro
    responsavelAcademico
    autorizadoBuscar
    contatoEmergencia
    guardaCompartilhada
    prioridadeContato
    observacoes
    aluno {
      id
      matricula
      pessoa {
        id
        nome
        nomeSocial
        dataNascimento
        fotoUrl
        cpf
        email
        telefoneCelular
        genero
      }
      matriculas {
        id
        status
        dataMatricula
        turma {
          id
          nome
          anoLetivo {
            id
            ano
            dataInicio
            dataFim
          }
          escola {
            id
            nomeFantasia
            nomeOficial
          }
        }
      }
      fichaMedica {
        id
        tipoSanguineo
        alergias
        condicoesMedicas
        medicamentosContinuos
        contatoEmergenciaNome
        contatoEmergenciaTelefone
        contatoEmergenciaParentesco
        laudosMedicos
        criadoEm
        atualizadoEm
      }
    }
  }
`;
export const ResponsavelCompletoFieldsFragmentDoc = gql`
    fragment ResponsavelCompletoFields on ResponsavelType {
  id
  pessoaId
  pessoa {
    ...PessoaBasicFields
  }
  filhos {
    ...ResponsaveisOnAlunosFields
  }
}
    ${PessoaBasicFieldsFragmentDoc}
${ResponsaveisOnAlunosFieldsFragmentDoc}`;